import { render, staticRenderFns } from "./regimesContratacaoEditar.vue?vue&type=template&id=55a2e860&scoped=true&"
import script from "./regimesContratacaoEditar.vue?vue&type=script&lang=js&"
export * from "./regimesContratacaoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2e860",
  null
  
)

export default component.exports